<script setup lang="ts">
import { IconEye, IconEyeOff } from '@tabler/icons-vue';
import { ref, useTemplateRef } from 'vue';

defineOptions({ inheritAttrs: false });

defineProps<{ disabled?: boolean }>();

const password = defineModel<string>({ required: true });
const visible = ref(false);
const input = useTemplateRef('input');

defineExpose({ focus: () => input.value?.focus() });
</script>

<template>
    <div class="input-container">
        <input
            ref="input"
            v-model="password"
            v-bind="$attrs"
            class="input"
            :type="visible ? 'text' : 'password'"
            :disabled="disabled"
        />

        <button
            type="button"
            class="btn btn--icon btn--transparent btn--inset"
            :disabled="disabled"
            @click="visible = !visible"
            @mousedown.prevent
        >
            <IconEyeOff v-if="visible" class="icon" />
            <IconEye v-else class="icon" />
            <ui-tooltip>{{ visible ? 'Hide Password' : 'Show Password' }}</ui-tooltip>
        </button>
    </div>
</template>
